import React from 'react';
import { IconArrowLeft } from '../../icons/svg';
import ImagePopup from '../image-popup.jsx';
import { SCREEN } from '../info-view-content.jsx';

export default class Image extends React.PureComponent {
   constructor(props) {
      super(props);
      this.state = {
         showPopup: false,
         srcImg: ''
      }

      this.handleShowImage = this.handleShowImage.bind(this);
      this.handleCloseImage = this.handleCloseImage.bind(this);
   }

   handleShowImage(src) {
      this.setState({
         srcImg: src,
         showPopup: true
      });
   }

   handleCloseImage() {
      this.setState({
         srcImg: '',
         showPopup: false
      });
   }

   render() {
      return (
         <div className="info-image">
            <div className="header" onClick={() => this.props.handleSetScreen(SCREEN.INFO)}>
               <div className="icon"><IconArrowLeft /></div>
               <div className="name">{this.props.title}</div>
            </div>
            <div className="list-image">
               <div className="img" onClick={() => this.handleShowImage('https://newsmd2fr.keeng.vn/tiin/archive/imageslead/2023/12/04/thumb00_qchqold5nlagqm3dq6rsuitut29jekwz7.jpg')}>
                  <img src="https://newsmd2fr.keeng.vn/tiin/archive/imageslead/2023/12/04/thumb00_qchqold5nlagqm3dq6rsuitut29jekwz7.jpg" alt="" />
               </div>
               <div className="img" onClick={() => this.handleShowImage('https://newsmd2fr.keeng.vn/tiin/archive/imageslead/2023/12/04/thumb00_qchqold5nlagqm3dq6rsuitut29jekwz7.jpg')}>
                  <img src="https://newsmd2fr.keeng.vn/tiin/archive/imageslead/2023/12/04/thumb00_qchqold5nlagqm3dq6rsuitut29jekwz7.jpg" alt="" />
               </div>
               <div className="img" onClick={() => this.handleShowImage('https://newsmd2fr.keeng.vn/tiin/archive/imageslead/2023/12/04/thumb00_qchqold5nlagqm3dq6rsuitut29jekwz7.jpg')}>
                  <img src="https://newsmd2fr.keeng.vn/tiin/archive/imageslead/2023/12/04/thumb00_qchqold5nlagqm3dq6rsuitut29jekwz7.jpg" alt="" />
               </div>
               <div className="img" onClick={() => this.handleShowImage('https://newsmd2fr.keeng.vn/tiin/archive/imageslead/2023/12/04/thumb00_qchqold5nlagqm3dq6rsuitut29jekwz7.jpg')}>
                  <img src="https://newsmd2fr.keeng.vn/tiin/archive/imageslead/2023/12/04/thumb00_qchqold5nlagqm3dq6rsuitut29jekwz7.jpg" alt="" />
               </div>
               <div className="img" onClick={() => this.handleShowImage('https://newsmd2fr.keeng.vn/tiin/archive/imageslead/2023/12/04/thumb00_qchqold5nlagqm3dq6rsuitut29jekwz7.jpg')}>
                  <img src="https://newsmd2fr.keeng.vn/tiin/archive/imageslead/2023/12/04/thumb00_qchqold5nlagqm3dq6rsuitut29jekwz7.jpg" alt="" />
               </div>
               <div className="img" onClick={() => this.handleShowImage('https://newsmd2fr.keeng.vn/tiin/archive/imageslead/2023/12/04/thumb00_qchqold5nlagqm3dq6rsuitut29jekwz7.jpg')}>
                  <img src="https://newsmd2fr.keeng.vn/tiin/archive/imageslead/2023/12/04/thumb00_qchqold5nlagqm3dq6rsuitut29jekwz7.jpg" alt="" />
               </div>
            </div>
            {this.state.showPopup &&
               <ImagePopup
                  src={this.state.srcImg}
                  onClose={this.handleCloseImage}
               />
            }
         </div>
      )
   }

}